export default "__VITE_ASSET__7754b9bf__"